'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createApiContext;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTimeout = 5000;
var defaultRetryLimit = 0;
var defaultPartnerId = 'qZjjnm85';
var defaultStreamFormats = 'mp3,aac,ogg,flash';

function createApiContext(config, requestHeaders, onTrackingEvent) {
  var tokens = {};

  var headers = _extends({
    'Content-Type': 'application/json'
  }, requestHeaders);

  function setAuthHeader(token) {
    if (token) {
      headers.Authorization = 'Bearer ' + token;
    }
  }

  function clearAuthHeader() {
    delete headers.Authorization;
  }

  function setTokens(tokenData) {
    if (!(0, _isEmpty2.default)(tokenData)) {
      tokens.accessToken = tokenData.accessToken;
      tokens.refreshToken = tokenData.refreshToken;

      setAuthHeader(tokenData.accessToken);
    }
  }

  function clearTokens() {
    delete tokens.accessToken;
    delete tokens.refreshToken;

    clearAuthHeader();
  }

  function getTokens() {
    return tokens;
  }

  /**
   * setCookies - sets cookie(s) in a `key=value; ` cookie string format on the request headers for
   * all API calls.
   *
   * @param  {string} cookieString - `key=value` string format.
   */
  function setCookies(cookieString) {
    if (headers.cookie) {
      headers.cookie = headers.cookie + '; ' + cookieString;
    } else {
      headers.cookie = cookieString;
    }
  }

  var apiContext = {
    params: {
      formats: config.streamFormats || defaultStreamFormats,
      serial: config.serial,
      partnerId: config.partnerId || defaultPartnerId,
      version: config.version,
      desktopVersion: config.desktopVersion,
      itemUrlScheme: 'secure',
      tid: config.tid,
      mode: config.mode
    },
    headers: headers,
    setTokens: setTokens,
    clearTokens: clearTokens,
    getTokens: getTokens,
    track: function track(event) {
      if (onTrackingEvent) {
        onTrackingEvent(event);
      }
    },
    timeout: config.timeout || defaultTimeout,
    apiHttpsAgent: config.apiHttpsAgent,
    retryLimit: config.retryLimit || defaultRetryLimit,
    setCookies: setCookies,
    logCookieNames: config.logCookieNames,
    isGraphQlEnabled: false,
    enableGraphQl: function enableGraphQl() {
      this.isGraphQlEnabled = true;
    }
  };

  apiContext.enableGraphQl = apiContext.enableGraphQl.bind(apiContext);

  return apiContext;
}
//# sourceMappingURL=createApiContext.js.map